import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

// Components
import TopHeader from "./components/TopHeader";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Feedback from "./components/Feedback";
import Login from "./components/Login";
import Signup from "./components/Signup";

// Pages
import Home from "./Pages/Home";
import About from "./Pages/About";
import Products from "./Pages/Products";
import Services from "./Pages/Services";
import Events from "./Pages/Events";
import Gallery from "./Pages/Gallery";
import Testimonials from "./Pages/Testimonials";
import Contact from "./Pages/Contact";
import FAQ from "./Pages/FAQ";
import Outlets from "./Pages/Outlets";

// Admin
import Admin from "./admin/Admin";
import PrivateRoute from "./admin/PrivateRoute";
// import AdminLogin from "./admin/AdminLogin";
// import AdminRegister from "./admin/AdminRegister";

import "./App.css";

// ✅ ScrollToTop component (you can also move this to a separate file)
const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const AppContent = () => {
  const location = useLocation();
  const path = location.pathname.toLowerCase();

  // Hide Navigation and Footer for admin routes
  const hideNavigation =
    path.startsWith("/admin") ||
    path === "/adminlogin" ||
    path === "/adminregister";

  return (
    <>
      {!hideNavigation && <TopHeader />}
      {!hideNavigation && <Navigation />}

      <ScrollToTop /> {/* ✅ Scrolls to top when page changes */}

      <Routes>
        {/* Public Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/services" element={<Services />} />
        <Route path="/events" element={<Events />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/outlets" element={<Outlets />} />

        {/* Public Auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/feedback" element={<Feedback />} />

        {/* Admin Routes */}
        {/* <Route path="/adminlogin" element={<AdminLogin />} />
        <Route path="/adminregister" element={<AdminRegister />} /> */}

        {/* Protected Admin Page */}
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <Admin />
            </PrivateRoute>
          }
        />
      </Routes>

      {!hideNavigation && <Footer />}
    </>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
